import { render, staticRenderFns } from "./productionView.vue?vue&type=template&id=e7bf0bfc&scoped=true"
import script from "./productionView.vue?vue&type=script&lang=js"
export * from "./productionView.vue?vue&type=script&lang=js"
import style0 from "./productionView.vue?vue&type=style&index=0&id=e7bf0bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7bf0bfc",
  null
  
)

export default component.exports